// removed by extract-text-webpack-plugin
module.exports = {"marketGroup":"FOiU0Xdpgp3CY2MfjT1i2","marketType":"_1f0UWIIpfpjeFujtRQV-Lz","winningMarginTeamHeader":"_3Iw2MlIwHKL5qRk19XlM8J","scoreGroup":"pad4Bsapc097yGjtAeHLx","marketText":"_7epD4WPCcUUkgIO-5WjY7","oddsButton":"_2LPPf2PVd0wBdBFxg5Qh0-","scoreGroup2ndLevel":"_2g8cPsePSZSD3RgqPcflzm"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/sports-book/modules/americanFootball/css/markets.css
// module id = 161
// module chunks = 0